"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
_Object$defineProperty(exports, "TimesheetUtil", {
  enumerable: true,
  get: function get() {
    return _timesheet["default"];
  }
});
var _timesheet = _interopRequireDefault(require("./timesheet"));
function cov_1fj4qgc2ts() {
  var path = "/home/node/project/src/index.js";
  var hash = "225ec27639eee096d1a6af6d1c99573470d5d624";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/home/node/project/src/index.js",
    statementMap: {},
    fnMap: {},
    branchMap: {},
    s: {},
    f: {},
    b: {},
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "225ec27639eee096d1a6af6d1c99573470d5d624"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_1fj4qgc2ts = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_1fj4qgc2ts();